/* eslint-disable prettier/prettier */
/* prettier-ignore-file */

import { useState, useEffect, useCallback } from 'react';

import { userService, LearnerDashboardCounts } from '../services/userService';

// export const useLearnerDashboardCounts = () => {
//     const [dashboardCounts, setDashboardCounts] =
//         useState<LearnerDashboardCounts | null>(null);

//     const [loading, setLoading] = useState(false);

//     const [error, setError] = useState<string | null>(null);

//     const fetchDashboardCounts = useCallback(async () => {
//         try {
//             setLoading(true);
//             setError(null);

//             const data =
//                 await userService.getLearnerDashboardCounts();

//             setDashboardCounts(data);
//         } catch (err: any) {
//             setError(
//                 err.message || 'Failed to fetch dashboard counts'
//             );
//         } finally {
//             setLoading(false);
//         }
//     }, []);

//     useEffect(() => {
//         fetchDashboardCounts();
//     }, [fetchDashboardCounts]);

//     return {
//         dashboardCounts,
//         loading,
//         error,
//         refetch: fetchDashboardCounts,
//     };
// };
export const useLearnerDashboardCounts = (courseid?: string) => {
	const [dashboardCounts, setDashboardCounts] =
		useState<LearnerDashboardCounts | null>(null);

	const [loading, setLoading] = useState(false);

	const [error, setError] = useState<string | null>(null);

	const fetchDashboardCounts = useCallback(async () => {
		try {
			setLoading(true);

			setError(null);

			const data = await userService.getLearnerDashboardCounts(courseid);

			setDashboardCounts(data);
		} catch (err: any) {
			setError(err.message || 'Failed to fetch dashboard counts');
		} finally {
			setLoading(false);
		}
	}, [courseid]);

	useEffect(() => {
		fetchDashboardCounts();
	}, [fetchDashboardCounts]);

	return {
		dashboardCounts,
		loading,
		error,
		refetch: fetchDashboardCounts,
	};
};
